import {MvsCrudService} from "../../../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {ConfirmationService} from "primeng/api";
import {HouseholdService} from "../../../../../../pm/service/api/household.service";
import {Observable} from "rxjs";
import {PersonRelationPersonDto} from "../../../../../../pm/model/dto/entity/person-relation-person.dto";
import {HouseholdPersonDto} from "../../../../../../pm/model/dto/entity/household-person.dto";
import {CrCustomerEmergencyContactDto} from "../../../../../../cm/model/dto/entity/customer-emergency-contact.dto";
import {HouseholdDto} from "../../../../../../pm/model/dto/entity/household.dto";
import {CustomerService} from "../../../../../service/api/customer.service";
import {CustomerEmergencyContactService} from "../../../../../service/api/customer-emergency-contact.service";
import {ObjectBaseComponent} from "../../../../../../../core/shared/object/mvs-object-base/object-base.component";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {WidgetData} from "../../../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../../core/shared/service/message/mvs-message.service";
import {MvsConfigService} from "../../../../../../../core/shared/config/mvs-config.service";
import {ObserverService} from "../../../../../../../core/shared/object/service/observer.service";
import {WidgetFactory} from "../../../../../../../core/shared/widget/service/widget.factory";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {Sorting} from "../../../../../../../core/shared/misc/sorting";
import {ObjectIdentifierData} from "../../../../../../../core/shared/basic/object-identifier-data";
import {FlexibleSearchDataEvent} from "../../../../../../../core/shared/search/components/flexible-search-data.event";
import {DtoDetail} from "../../../../../../../core/shared/dto/dto.detail";
import {
    WidgetToolbarCallbackInterface
} from "../../../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {ObjectChangeInformation} from "../../../../../../../core/shared/logic/object-change-information";
import {MvsFormControlOverwrite} from "../../../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {DtoList} from "../../../../../../../core/shared/dto/dto.list";
import {PersonDto} from "../../../../../../pm/model/dto/entity/person.dto";
import {QlJoinDto} from "../../../../../../../core/shared/ql/data/dto/ql-join.dto";

// Duplicate Component name
@Component({
    selector: 'cr-create-emergency-contact',
    templateUrl: './cr-create-emergency-contact.component.html',
    standalone: false
})
export class CrCreateEmergencyContactComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    householdPersonService: MvsCrudService;
    @Input() customerId: number;
    @Input() customerPersonId: number;

    @Output() onObjectSelected: EventEmitter<ObjectIdentifier> = new EventEmitter<ObjectIdentifier>();

    stepItems = [];
    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    activeStep: number;

    selectedCustomerRelatedPersonId: number;
    selectedPersonId: number;
    personRelationCreated: boolean;

    customerRelatedPersonWidget: WidgetData;
    personRelationPersonForm: WidgetData;
    customerEmergencyContactForm: WidgetData;
    personFormWidget: WidgetData;

    flexiblePersonSearchDto: PersonDto;

    constructor(protected route: ActivatedRoute,
                protected coreService: MvsCoreService,
                protected customerService: CustomerService,
                protected confirmationService: ConfirmationService,
                protected messageService: MvsMessageService,
                protected configService: MvsConfigService,
                protected customerEmergencyContactService: CustomerEmergencyContactService,
                protected householdService: HouseholdService,
                protected override observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);


        this.householdPersonService = this.coreService.getCrudService("pm.HouseholdPerson");
        // this component is only used to create
        this.createOnly = true;
    }


    protected getRetrieveObjectObservable(): Observable<any> {
        return null;
    }

    ngOnInit(): void {
        this.initComponent();
    }


    /**
     * Initialize Component.
     */
    initComponent() {
            this.refreshComponent();
    }

    resetComponent() {

        this.selectedCustomerRelatedPersonId = undefined;
        this.selectedPersonId = undefined;
        this.customerRelatedPersonWidget = undefined;
        this.personRelationPersonForm = undefined;
        this.personFormWidget = undefined;
        this.flexiblePersonSearchDto = undefined;
    }

    /**
     * Retrieve import variables either from the direct variables customerId and contractId or from the ImportObjectContext.
     */
    retrieveImportVariables() {

        if (this.importObjectContext) {

            if (!this.customerId) {
                const customerEntry = this.importObjectContext.getEntry("cr.Customer");
                if (customerEntry) {
                    this.customerId = customerEntry.id;
                }
            }

            this.customerService.get(this.customerId).subscribe(res => {
                this.customerPersonId = res['personDtoId'];
                this.gotoStep(0);
            })


        }

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.resetComponent();

        this.retrieveImportVariables();

        this.stepItems = [
            {
                label: 'Überprüfen, ob vorhanden', id: 'check'   // Check if exist
            },
            {
                label: 'Person suchen', id: 'search'  // Select Person
            },
            {
                label: 'Person erstellen', id: 'create'  // Create New Person
            },
            {
                label: 'Kunden zuweisen', id: 'assignCustomer'  // Create Customer Relation
            },
            // {
            //     label: 'Notfallkontakt anlegen', id: 'createEmergencyContact'
            // }
        ];


        this.initialized = true;

    }


    /**
     * Initialize Step 1)
     * Check whether Customer Related Person already exists.
     */
    initStep0() {



        const widgetJoin: QlJoinDto[] = [
            {
                joinType: "left",
                type: "entity",
                name: "personA",
                as: "pa",
                fields: [
                    {
                        name: "id",
                    },
                    {
                        name: "calculatedName",
                    },
                    {
                        name: "gender",
                    }
                ]
            },
            {
                joinType: "left",
                type: "entity",
                name: "relationTypeA",
                as: "ra",
                fields: [
                    {
                        name: "id",
                    },
                    {
                        name: "name",
                    },
                    {
                        name: "specificGender",
                    }
                ]
            },
            {
                joinType: "left",
                type: "entity",
                name: "personB",
                as: "pb",
                fields: [
                    {
                        name: "id",
                    },
                    {
                        name: "calculatedName",
                    },
                    {
                        name: "gender",
                    }
                ]
            },
            {
                joinType: "left",
                type: "entity",
                name: "relationTypeB",
                as: "rb",
                fields: [
                    {
                        name: "id",
                    },
                    {
                        name: "name",
                    },
                    {
                        name: "specificGender",
                    }
                ]
            }
        ];


        this.customerRelatedPersonWidget = WidgetFactory.createWidgetQl(
            'cm.create.customer.relation.person.basic.customer.related.persons.new',
            'Personen im Zusammenhang mit Kunden',
            'pm.PersonRelationPerson',
            "list",
            [FilterCriteria.create("e.personAId", FilterCriteria.cOperatorEqual, this.customerPersonId)],
            [new Sorting("e.createdDate", true)],
            widgetJoin
        );

    }

    /**
     * A related person was selected, therefore we need to decide how to continue.
     */
    handleStep0RelatedPersonSelect(objectIdentifier: ObjectIdentifierData | ObjectIdentifier) {

        this.selectedPersonId = objectIdentifier['data']['pb.id'];
        this.gotoStep(4);

    }

    gotoStep(step: number) {

        switch (step) {
            case 0:             // search customer persons
                this.initStep0();

                break;
            case 1:             // search persons
                this.initStep1();

                break;
            case 2:             // create person
                this.initStep2();
                break;

            case 3:             // create customer - person assignment
                this.initStep3();
                break;

            case 4:             // create customer - person assignment
                this.initStep4();
                break;

        }
        this.activeStep = step;

    }

    /**
     * Initialize Step 2)
     * Within this step the user needs to search for a person.
     */
    initStep1() {
        // no initialization required
    }


    /**
     * User has selected a person.
     * @param event
     */
    handlePersonSelectStep1(event: FlexibleSearchDataEvent) {
        this.selectedPersonId = event.id;
    }

    /**
     * Continue with step 3.
     */
    handleContinueWithSelectedPersonStep1() {
        if (this.selectedPersonId) {
            this.gotoStep(3);
        }
    }

    /**
     * Store search result.
     * @param event
     */
    handlePersonSearchStep1(event: DtoDetail) {
        this.flexiblePersonSearchDto = <PersonDto>event;
    }

    /**
     * User requests to create a new person.
     */
    handleCreateNewPersonStep1() {

        // only allow to move to the next step, if user actually searched
        if (!this.flexiblePersonSearchDto) {
            this.confirmationService.confirm({
                header: 'Alert',
                message: 'Bitte suchen Sie nach der Person, bevor Sie eine neue Person erstellen!',
                acceptLabel: 'Okay',
                rejectVisible: false, // Hide the cancel button
                accept: () => {
                }
            });

            return;
        }

        this.gotoStep(2);

    }


    /**
     * Step 3) Create a new person.
     */
    initStep2() {

        this.personFormWidget = WidgetFactory.createWidgetObjectWithCallback(
            "cm.create.customer.related.person.object.create.person.form.widget",
            "Person erstellen",
            "pm.Person",
            {
                onFunctionObjectDefaultNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                    return {dto: this.flexiblePersonSearchDto};
                }
            }
        );

    }

    /**
     * Person was successfully created so we can move to the next step.
     * @param objectChangeInformation
     */
    handlePersonCreateStep2(objectChangeInformation: ObjectChangeInformation) {
        this.selectedPersonId = objectChangeInformation.after.id;
        this.gotoStep(3);
    }

    initStep3() {

        this.personRelationPersonForm = WidgetFactory.createWidgetObjectWithCallback(
            'cm.create.person.relation.person.object.create.form.widget',
            'Zuweisung Kunde',
            'pm.PersonRelationPerson',
            {
                onFunctionObjectDefaultNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                    const dto = new PersonRelationPersonDto();
                    dto.personADtoId = this.customerPersonId;
                    dto.personBDtoId = this.selectedPersonId;

                    const formControlOverwrite = new MvsFormControlOverwrite();
                    formControlOverwrite.addField('personADtoId', MvsFormFieldAccessEnum.READ);
                    formControlOverwrite.addField('personBDtoId', MvsFormFieldAccessEnum.READ);

                    let widgetToolbarCallbackInterface: WidgetToolbarCallbackInterface;
                    widgetToolbarCallbackInterface = {
                        dto: dto,
                        formControlOverwrite: formControlOverwrite
                    };
                    return widgetToolbarCallbackInterface;
                }
            }
        );
    }

    handleSameHousehold() {
        const request = new ObjectRequestList(
            false,
            [FilterCriteria.create('person', FilterCriteria.cOperatorEqual, this.customerPersonId)],
            []
        );

        this.householdPersonService.list(request).subscribe((res: DtoList<HouseholdPersonDto>) => {
            if (!res.entries || !res.entries.length) {
                // create a new household
                this.handleCreateNewHousehold(this.customerPersonId, this.selectedPersonId);

                this.gotoStep(4);
            } else {
                // update household person
                const householdId = res.entries[0].householdDtoId;
                this.updateExistingHousehold(householdId);
            }
        })
    }

    updateExistingHousehold(householdId: number) {
        this.createHouseholdPerson(this.selectedPersonId, householdId);
        this.gotoStep(4);
    }

    handleCreateRelatedPersonStep3(objectChangeInformation: ObjectChangeInformation) {
        this.personRelationCreated = true;
    }

    personCreationFinished(objectIdentifier: ObjectIdentifier) {
        this.onObjectSelected.emit(objectIdentifier);
        this.refreshComponent();
    }


    initStep4() {
        this.createEmergencyContact();
        // this.initEmergencyContactForm();
    }

    createEmergencyContact() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        const dto = new CrCustomerEmergencyContactDto();
        dto.customerDtoId = this.customerId;
        dto.personDtoId = this.selectedPersonId;
        dto.endDate = new Date('9999-12-31');

        this.customerEmergencyContactService.create(dto).subscribe(res => {
           this.messageService.showSuccessMessage('','Notfallkontakt erfolgreich erstellt');
            this.personCreationFinished(new ObjectIdentifier('cr.CustomerEmergencyContact', res.id));
           this.busy = false;
        }, error => {
            this.messageService.showErrorMessage('Error', error);
            this.busy = false;
        });
    }

    initEmergencyContactForm() {

        this.customerEmergencyContactForm = WidgetFactory.createWidgetObjectWithCallback(
            "cm.create.emergency.contact.form.emergency.contact",
            "Notfallkontakt erfassen",
            "cr.CustomerEmergencyContact",
            {
                onFunctionObjectDefaultNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                    const dto = new CrCustomerEmergencyContactDto();
                    dto.customerDtoId = this.customerId;
                    dto.personDtoId = this.selectedPersonId;

                    const formControlOverwrite = new MvsFormControlOverwrite();
                    formControlOverwrite.addField('personDtoId', MvsFormFieldAccessEnum.READ);
                    formControlOverwrite.addField('customerDtoId', MvsFormFieldAccessEnum.HIDDEN);

                    return {
                        dto: dto,
                        formControlOverwrite: formControlOverwrite
                    };

                }
            }
        );
    }

    handleContactEmergencyContactCreated(event: ObjectChangeInformation) {
        this.personCreationFinished(new ObjectIdentifier('cr.CustomerEmergencyContact', event.after.id));
    }

    handleCompleteWithoutCreatingHousehold() {
        this.gotoStep(4);

    }

    handleCreateNewHousehold(personA: number, personB: number) {
        const dto = new HouseholdDto();
        this.householdService.create(dto).subscribe(res => {
            this.createHouseholdPerson(personA, res.id);
            this.createHouseholdPerson(personB, res.id);
        });
    }

    createHouseholdPerson(personId: number, householdId: number) {
        const dto = new HouseholdPersonDto();
        dto.householdDtoId = householdId;
        dto.personDtoId = personId;
        dto.endDate = new Date();

        this.householdPersonService.create(dto).subscribe(res => {
        });
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"] || changes["contractId"] || changes["customerId"]) {
            this.initComponent();
        }

        if (changes["importObjectContext"]) {
            this.initComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
